<template lang="pug">
  Auth(@loginFailed="onFailedAuthentication")
    Header(:content="headerContent")
    div.wrap-settings
      div.list-setting
        div.list-content.py12
          a(href='https://healthcarecatalyst.org/privacy_policy.html' target='brank') プライバシーポリシー
      div.list-setting
        div.list-content.py12
          a(href='https://healthcarecatalyst.org/service_terms.html' target='brank') 利用規約
      div.list-setting
        div.list-content.py12
          a(href='https://forms.gle/TbWA4nq9rBkbeHeU9' target='brank') ご意見・ご要望
      div.list-setting
        div.list-content.py12
          span(@click="logout").logout ログアウト
</template>

<style lang="scss" scoped>
.wrap-settings {
  width: 100%;
  min-height: 100vh;
  padding-top: 48px;
  .list-setting {
    border-bottom: solid 0.8px rgba(0, 0, 0, 0.4);
    .list-content {
      width: 93%;
      max-width: 820px;
      margin: 0 auto;
      a {
        color: #2a2a2a;
      }
      .logout {
        color: #ff5252;
      }
    }
  }
}
</style>

<script>
import db from '@/components/utils/firebase'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')
import Auth from '@/components/auth'
import Header from '@/components/shared/Header.vue'

export default {
  components: {
    Auth,
    Header
  },
  data () {
    return {
      // headerContent: {
      //   label: '',
      //   leftAction: {
      //     icon: 'playlist_add_check',
      //     color: '#fff',
      //     method: this.toCourseList
      //   },
      //   rightActions: [
      //     {
      //       icon: 'person',
      //       color: '#fff',
      //       method: this.toMyPage
      //     },
      //     {
      //       icon: 'settings',
      //       color: '#fff',
      //       method: this.toSettings
      //     }
      //   ]
      // }
      headerContent: {
        label: '',
        leftAction: {
          icon: 'person',
          color: '#fff',
          method: this.toMyPage
        },
        rightActions: [
          {
            icon: 'settings',
            color: '#fff',
            method: this.toSettings
          }
        ]
      }
    }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  methods: {
    ...mapActionsAuth(['signOut']),
    onFailedAuthentication () {
      this.$router.push('/sign-in')
    },
    logout () {
      this.signOut()
      setTimeout(() => {
        this.$router.push('/sign-in')
      }, 400)
    },
    onHeaderRight () {

    },
    toCourseList () {
      this.$router.push('/course/digital_learning')
    },
    toMyPage () {
      this.$router.push(`/users/${this.uid}`)
    },
    toSettings () {
      this.$router.push('/settings')
    }
  }
}
</script>
